<template>
  <div class="collection-detail" v-if="detail">

    <div class="main">
      <div class="detail">
        <div class="title">{{detail.title}}</div>
        <div class="desc" v-html="detail.desc"></div>
        <div class="variation">
          <div class="text">Variation</div>
          <div class="images">
            <template v-for="(item ,i) in detail.variationList">
              <router-link class="img hover-border border2px" :key="i" :to="`/collections/${item.id}`" target="_blank"><img :src="`${options.cdn}/${item.image}` | img"/></router-link>
            </template>
          </div>
        </div>
      </div>

      <div class="image" v-if="detail.image">
        <img :src="`${options.cdn}/${detail.image}`"/>
      </div>

    </div>

    <div class="image-list">

      <template v-for="(item ,i) in detail.images">
        <div class="img hover-border" :key="i" :class="`w-${item.width}`"><img :src="`${options.cdn}/${item.url}`"/></div>
      </template>

      <!--<div class="w50">-->
        <!--<div class="img hover-border">-->
          <!--<img src="../assets/images/detail-img-1.jpg"/>-->
        <!--</div>-->
        <!--<div class="img hover-border">-->
          <!--<img src="../assets/images/detail-img-1.jpg"/>-->
        <!--</div>-->
      <!--</div>-->

    </div>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'collection-detail',
    computed: {
      ...mapState(['options'])
    },
    data() {
      return {
        detail: null
      }
    },
    async mounted () {
      const id = this.$route.params.id
      this.detail = await this.axios.get(`/collections/${id}`)
      this.detail.images = JSON.parse(this.detail.images)
    }
  }
</script>

<style lang="stylus" scoped>
  .collection-detail
    padding 20px

    .main
      display flex

      > div
        flex-basis calc((100% - 20px) / 2)

      .detail
        margin-right 20px
        padding 30px 60px 0 72px

        .title
          font-size 2.2rem
          font-family 'NeutraText-BoldAlt'

        .desc
          line-height 1.4
          font-family 'NeutraText-Book'
          margin-top 20px

        .variation
          margin-top 1.8rem

          .text
            font-size 2rem

          .images
            margin-top 20px
            .img
              display inline-block
              width calc((100% - 60px) / 5)
              margin-right 15px

              img
                width 100%

      .image
        border 4px solid #000

        img
          width 100%

    .image-list
      .img
        display inline-block
        width 100%
        margin 10px

        &.w-50
          width calc((100% - 40px) / 2)

        img
          width 100%

  @media screen and (max-width: 768px)
    .collection-detail
      padding 0

      .main
        flex-wrap wrap

        .image
          border none

        .detail
          order 2
          padding 20px
          margin 0

          .variation
            .images
              width 100%
              flex-wrap wrap
              display flex
              justify-content space-between

              .img
                margin-right 0
                width 0
                flex-basis calc((100% - 15px) / 2)

        > div
          flex-basis 100%

      .image-list
        padding 20px
</style>
